module.exports = __webpack_public_path__ + "media/images/logo-circle-4c96d74d.svg";